import { useState } from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';

import { LpTitle } from '../../../atoms/lp/LpTitle';
import { LpAdLanguageSlider } from '../../../molecules/lp/ad/LpAdLanguageSlider';
import { LpAdLanguageScroll } from '../../../molecules/lp/ad/LpAdLanguageScroll';
import { LpAdIconLanguage } from '../../../molecules/lp/ad/LpAdIconLanguage';
import { Loader } from '../../../../common/Loader';
import { LpAdAwsContent } from './LpAdAwsContent';

import IconHtml from '../../../../static/image/lp/tag/html.png';
import IconJavascript from '../../../../static/image/lp/tag/javascript.png';
import IconPhp from '../../../../static/image/lp/tag/php.png';
import IconChatGpt from '../../../../static/image/lp/tag/chat_gpt.png';
import IconLaravel from '../../../../static/image/lp/tag/laravel.png';
import IconHeroku from '../../../../static/image/lp/tag/heroku.png';
import IconIt from '../../../../static/image/lp/tag/it.png';
import IconGit from '../../../../static/image/lp/tag/git.png';
import IconJava from '../../../../static/image/lp/tag/java.png';
import IconFigma from '../../../../static/image/lp/tag/figma.png';
import IconSql from '../../../../static/image/lp/tag/sql.png';
import IconPython from '../../../../static/image/lp/tag/python.png';
import IconDataScience from '../../../../static/image/lp/tag/data_science.png';
import IconGas from '../../../../static/image/lp/tag/gas.png';
import IconAi from '../../../../static/image/lp/tag/ai.png';
import IconPhotoshop from '../../../../static/image/lp/tag/photoshop.png';
import IconUiUx from '../../../../static/image/lp/tag/ui_ux.png';
import IconLinux from '../../../../static/image/lp/tag/linux.png';
import IconCareer from '../../../../static/image/lp/tag/career.png';
import IconFreelance from '../../../../static/image/lp/tag/freelance.png';
import IconWordPress from '../../../../static/image/lp/tag/wordpress.png';

import { useGetProgramQuery } from '../../../../gen/graphql';
import { getChapters } from '../../../pages/common/programs/programUtil';
import { PROGRAM_COUNT } from '../../../../const/Program';

interface Program {
  id: number;
  name: string;
  image: string;
}

const programList: Program[] = [
  {
    id: 51,
    name: 'HTML/CSS',
    image: IconHtml,
  },
  {
    id: 61,
    name: 'JavaScript',
    image: IconJavascript,
  },
  {
    id: 98,
    name: 'Python',
    image: IconPython,
  },
  {
    id: 122,
    name: 'ChatGPT',
    image: IconChatGpt,
  },
  {
    id: 76,
    name: 'PHP',
    image: IconPhp,
  },
  {
    id: 152,
    name: 'Laravel',
    image: IconLaravel,
  },
  {
    id: 158,
    name: 'Java',
    image: IconJava,
  },
  {
    id: 181,
    name: 'Photoshop',
    image: IconPhotoshop,
  },
  {
    id: 186,
    name: 'Figma',
    image: IconFigma,
  },
  {
    id: 165,
    name: 'WordPress',
    image: IconWordPress,
  },
  {
    id: 184,
    name: 'UI/UX',
    image: IconUiUx,
  },
  {
    id: 91,
    name: 'AI',
    image: IconAi,
  },
  {
    id: 110,
    name: 'データサイエンス',
    image: IconDataScience,
  },
  {
    id: 109,
    name: 'GAS',
    image: IconGas,
  },
  {
    id: 105,
    name: 'Linux',
    image: IconLinux,
  },
  {
    id: 168,
    name: 'データベース',
    image: IconSql,
  },
  {
    id: 99,
    name: 'Git',
    image: IconGit,
  },
  {
    id: 81,
    name: 'Heroku',
    image: IconHeroku,
  },
  {
    id: 103,
    name: 'ITパスポート',
    image: IconIt,
  },
  {
    id: 14,
    name: 'エンジニアへ転職',
    image: IconCareer,
  },
  {
    id: 73,
    name: 'フリーランスエンジニア',
    image: IconFreelance,
  },
];

export const LpAdProgramSampleList: React.FC = () => {
  const { activeProgramId, switchActiveProgramId, programTitle, chapters, loading } = useLpAdProgramSampleList();

  return (
    <Container data-gtm="textbook">
      <StyledTtl>
        <h2>充実の教材</h2>
        <p>Textbook</p>
      </StyledTtl>
      <Description>
        未経験から即戦力エンジニアになるための実践型教材が{PROGRAM_COUNT}種類以上。
        <br />
        制作物は転職の面接時や案件獲得の際のポートフォリオとしてもお使いいただけます。
      </Description>
      <ProgramInner>
        {window.innerWidth < 768 ? (
          <LpAdLanguageScroll>
            {programList.map((program) => {
              return (
                <LpAdIconLanguage
                  key={program.id}
                  id={program.id}
                  name={program.name}
                  image={program.image}
                  active={activeProgramId === program.id}
                  switch={switchActiveProgramId}
                />
              );
            })}
          </LpAdLanguageScroll>
        ) : (
          <LpAdLanguageSlider>
            {programList.map((program) => {
              return (
                <LpAdIconLanguage
                  key={program.id}
                  id={program.id}
                  name={program.name}
                  image={program.image}
                  active={activeProgramId === program.id}
                  switch={switchActiveProgramId}
                />
              );
            })}
          </LpAdLanguageSlider>
        )}
        <ProgramList>
          {!loading ? (
            <>
              <ProgramTitle>{programTitle}</ProgramTitle>
              <ChapterList>
                {chapters?.slice(0, 9).map((chapter) => {
                  return (
                    <ChapterItem key={chapter.id}>
                      <ChapterInner>
                        <ChapterTitle>{chapter?.title}</ChapterTitle>
                        <ChapterDescription>{chapter?.description}</ChapterDescription>
                      </ChapterInner>
                    </ChapterItem>
                  );
                })}
              </ChapterList>
            </>
          ) : (
            <Loader width={'100%'} height={'630px'} margin={'0'} number={10} />
          )}
        </ProgramList>
      </ProgramInner>

      <LpAdAwsContent />
    </Container>
  );
};

const useLpAdProgramSampleList = () => {
  const [activeProgramId, setActiveProgramId] = useState(programList[0].id);

  const switchActiveProgramId = (id: number) => {
    setActiveProgramId(id);
  };

  const { data, loading } = useGetProgramQuery({
    variables: {
      programID: activeProgramId,
    },
  });
  const program = data?.program;
  const programTitle = program?.title ?? '';
  const chapters = program ? getChapters(program) : [];

  return {
    loading,
    activeProgramId,
    switchActiveProgramId,
    programTitle,
    chapters,
  };
};

const Container = styled.section`
  margin: 5.625rem auto 7.5rem;
  padding: 5.5rem 0 0;

  ${media.lessThan('medium')`
    margin: 4rem auto;
    padding: 4rem 1rem 0;
  `}
`;
const StyledTtl = styled(LpTitle)`
  margin-bottom: 3rem;

  ${media.lessThan('medium')`
    padding: 0 1rem;
    margin-bottom: 2rem;
  `}
`;
const Description = styled.p`
  margin-bottom: 3rem;
  font-size: 1.375rem;
  font-weight: 700;
  line-height: 2rem;
  text-align: center;

  ${media.lessThan('medium')`
    margin-bottom: 2rem;
    padding: 0 1rem;
    font-size: 1rem;
    line-height: 1.375rem;
  `}
`;
const ProgramInner = styled.div`
  max-width: 1056px;
  margin: 0 auto;
  padding: 3.75rem 2.25rem 4rem;
  background: #f8f8f8;
  border-radius: 1.25rem;
  box-sizing: border-box;

  ${media.lessThan('medium')`
    margin: 0 -1rem;
    padding: 2rem 1rem 4rem;
    border-radius: 0;
  `}
`;

const ProgramList = styled.div`
  max-width: 768px;
  margin: 3rem auto 0;

  ${media.lessThan('medium')`
    margin-top: 2rem;
  `}
`;
const ProgramTitle = styled.h3`
  margin-bottom: 1rem;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;

  ${media.lessThan('medium')`
    margin-bottom: 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
  `}
`;
const ChapterList = styled.ul`
  counter-reset: chapter;
  padding: 0.75rem 0;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);

  ${media.lessThan('medium')`
    padding: 0;
  `}
`;
const ChapterItem = styled.li`
  padding: 0.5rem 0.75rem;

  &:nth-of-type(n + 2) {
    counter-increment: chapter;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }

  ${media.lessThan('medium')`
    padding: 0.625rem 1rem;
  `}
`;
const ChapterInner = styled.div`
  padding-left: 3.375rem;
  position: relative;

  &:before {
    content: '0' counter(chapter);
    display: block;
    width: 1.625rem;
    height: 1.25rem;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.25;
    position: absolute;
    top: 0;
    left: 1.75rem;
  }

  ${media.lessThan('medium')`
    padding-left: 1.6875rem;

    &:before {
      width: 1.25rem;
      left: 0;
    }
  `}
`;
const ChapterTitle = styled.h4`
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.25;
`;
const ChapterDescription = styled.p`
  margin-top: 0.5rem;
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.8125rem;
  line-height: 1rem;

  ${media.lessThan('medium')`
    font-size: 0.75rem;
  `}
`;
